import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '-';
  // Date-only strings (YYYY-MM-DD) must render as the calendar day the backend
  // meant — never shifted by the browser's timezone. `new Date("2026-10-21")`
  // parses as UTC midnight and can display Oct 20 west of UTC, so build a
  // local date from the parts instead.
  const dateOnly = /^\d{4}-\d{2}-\d{2}$/.exec(String(dateString).trim());
  const date = dateOnly
    ? new Date(Number(dateOnly[0].slice(0, 4)), Number(dateOnly[0].slice(5, 7)) - 1, Number(dateOnly[0].slice(8, 10)))
    : new Date(dateString);
  if (isNaN(date.getTime())) return '-';
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return '-';
  // A bare date with no time component is a calendar day — show it as such
  // (no 12:00 AM) and without a timezone shift.
  if (/^\d{4}-\d{2}-\d{2}$/.test(String(dateString).trim())) return formatDate(dateString);
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '-';
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}

// Payroll money: integer cents → "$1,234.56" with thousands separators.
// Returns an em dash for null/undefined so empty cells read cleanly.
export function formatCents(cents) {
  if (cents === null || cents === undefined) return '—';
  return new Intl.NumberFormat('en-US', {
    style: 'currency', currency: 'USD',
  }).format(Number(cents) / 100);
}

export function getStatusColor(status) {
  const colors = {
    draft: 'bg-slate-100 text-slate-700',
    submitted: 'bg-blue-100 text-blue-700',
    approved: 'bg-green-100 text-green-700',
    picking: 'bg-yellow-100 text-yellow-700',
    ready: 'bg-purple-100 text-purple-700',
    issued: 'bg-emerald-100 text-emerald-700',
    fulfilled: 'bg-slate-200 text-slate-600',
    completed: 'bg-emerald-100 text-emerald-700',
    rejected: 'bg-red-100 text-red-700',
    cancelled: 'bg-slate-100 text-slate-500',
    sent: 'bg-indigo-100 text-indigo-700',
    partially_received: 'bg-orange-100 text-orange-700',
    closed: 'bg-emerald-100 text-emerald-700',
  };
  return colors[status] || 'bg-slate-100 text-slate-700';
}

export function getRoleLabel(role) {
  const labels = {
    admin: 'System Admin',
    warehouse: 'Warehouse Staff',
    manager: 'Manager',
    finance: 'Finance/Procurement',
    marketing: 'Marketing',
    fleet_manager: 'Fleet Manager',
  };
  return labels[role] || role;
}

export function truncate(str, length = 50) {
  if (!str) return '';
  return str.length > length ? str.substring(0, length) + '...' : str;
}
